import { z } from 'zod'
import { requiredText } from '../../../lib/forms/rules'

/** Sistem parametresi düzenleme form şeması (020): yalnız value zorunlu. */
export const systemParameterFormSchema = z.object({
  value: requiredText(),
})

export type SystemParameterFormValues = z.infer<typeof systemParameterFormSchema>
